import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Menu } from '@multimediasrl/emed-ui-shared';

import { jwtDecode } from 'jwt-decode';

import { lastValueFrom, Subscription } from 'rxjs';

import { CognitoSelector } from '../../state/selectors/cognito-selector';

@Component({
  selector: 'emed-main-dispatcher',
  templateUrl: './emed-main-dispatcher.component.html',
  styleUrl: './emed-main-dispatcher.component.scss',
  standalone: false
})
export class EmedMainDispatcherComponent implements OnInit, OnDestroy {
  protected isAuthenticated = false;
  protected idToken: any;
  protected accessToken: any;
  protected isConfigurazione: boolean;
  private subArray: Subscription[] = [];
  public menuItems: Menu[] = [];

  constructor(protected cognitoSelector: CognitoSelector, private http: HttpClient) {}

  ngOnDestroy(): void {
    this.subArray.forEach((x) => x.unsubscribe());
  }

  ngOnInit(): void {
    this.subArray.push(
      this.cognitoSelector.isAuthenticated$.subscribe((data) => {
        this.isAuthenticated = data;
      })
    );

    this.subArray.push(
      this.cognitoSelector.accessToken$.subscribe(async (data) => {
        try {
          this.accessToken = jwtDecode(data);
          console.log('accessToken: ' + JSON.stringify(this.accessToken));

          if (this.accessToken && this.accessToken['cognito:groups']) {
            const index = this.accessToken['cognito:groups'].findIndex((data: string) => data == 'Configurazione');
            this.isConfigurazione = index >= 0 ? true : false;

            if (this.isConfigurazione) {
              this.menuItems = await lastValueFrom(this.http.get<Menu[]>('./assets/configuration/menu.json'));
            }
          }
        } catch (Error) {
          return null;
        }
      })
    );

    this.subArray.push(
      this.cognitoSelector.idToken$.subscribe((data) => {
        try {
          this.idToken = jwtDecode(data);
          console.log('idToken: ' + JSON.stringify(this.idToken));
        } catch (Error) {
          return null;
        }
      })
    );
  }
}
